import React from "react";

interface DashboardIconProps {
    active?: boolean;
    size?: number;
}

const IconDevice: React.FC<DashboardIconProps> = ({ active = false, size = 24 }) => {
    const fillColor = active ? "#0F7679" : "#6A7878";

    return (
        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.5 16V14H2.30775C1.80258 14 1.375 13.825 1.025 13.475C0.675 13.125 0.5 12.6974 0.5 12.1923V2.30775C0.5 1.80258 0.675 1.375 1.025 1.025C1.375 0.675 1.80258 0.5 2.30775 0.5H17.6923C18.1974 0.5 18.625 0.675 18.975 1.025C19.325 1.375 19.5 1.80258 19.5 2.30775V12.1923C19.5 12.6974 19.325 13.125 18.975 13.475C18.625 13.825 18.1974 14 17.6923 14H11.5V16H12.75C12.9628 16 13.141 16.0718 13.2845 16.2155C13.4282 16.359 13.5 16.5372 13.5 16.75C13.5 16.9628 13.4282 17.141 13.2845 17.2845C13.141 17.4282 12.9628 17.5 12.75 17.5H7.25C7.03717 17.5 6.859 17.4282 6.7155 17.2845C6.57183 17.141 6.5 16.9628 6.5 16.75C6.5 16.5372 6.57183 16.359 6.7155 16.2155C6.859 16.0718 7.03717 16 7.25 16H8.5ZM2.30775 12.5H17.6923C17.7693 12.5 17.8398 12.468 17.9038 12.404C17.9679 12.3398 18 12.2692 18 12.1923V2.30775C18 2.23075 17.9679 2.16025 17.9038 2.09625C17.8398 2.03208 17.7693 2 17.6923 2H2.30775C2.23075 2 2.16025 2.03208 2.09625 2.09625C2.03208 2.16025 2 2.23075 2 2.30775V12.1923C2 12.2692 2.03208 12.3398 2.09625 12.404C2.16025 12.468 2.23075 12.5 2.30775 12.5Z" fill={fillColor} />
        </svg>
    );
};

export default IconDevice;
